<span
  class="message"
  *ngIf="message$ | async as message"
  [class.error]="message.status === statuses.Error"
  [class.success]="message.status === statuses.Success">
  {{ message.text }}
</span>